<script lang="ts" setup>
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';

import { useService } from '@nzyme/vue-ioc/useService.js';
import { AuthStore } from '@sigma/client/auth/AuthStore.js';
import { useLocale } from '@sigma/client/i18n/useLocale.js';
import { LandingRoute } from '@sigma/patient-common/routes.js';

const authStore = useService(AuthStore);
const router = useRouter();
const locale = useLocale();

onMounted(async () => {
  await authStore.logout();
  await router.replace(LandingRoute({ locale: locale.value }));
});
</script>

<template>
  <div />
</template>
